import React from 'react'
import propTypes from 'prop-types'
import Select from 'react-select'
import Slide from '@material-ui/core/Slide'

import LateralPanel from '../../common/lateralPanel/LateralPanel'
import { panelLateralServicesStyles } from '../../../resources/styles/PanelLateralServicesStyles'

import { Fab, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Clear'
import BarChartIcon from '@material-ui/icons/BarChart'
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep'

const SalesFilterPanel = (props) => {
	const classes = panelLateralServicesStyles()
	return (
		<Slide direction='left' in={props.open} mountOnEnter unmountOnExit timeout={500}>
			<div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
				<LateralPanel open={props.open} onClose={props.onClose} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
					<form style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
						<PanelHeader onClose={props.onClose} title={'Filter Sales'} />
						<div
							className={classes.panelContent}
							style={{
								flex: 1,
								overflowY: 'auto',
								height: '100%',
								minHeight: 'calc(100vh - 140px)',
								maxHeight: 'calc(100vh - 140px)',
							}}
						>
							<FilterBlock
								title='Sales Model'
								options={props.salesModels}
								field='salesModel'
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedSalesModels}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>

							<FilterBlock
								title='SKU'
								options={props.skus}
								field='materialPt'
								onFilterOptionClick={props.onFilterOptionClick}
								selectedValues={props.selectedSkus}
								onRemoveFilterOption={props.onRemoveFilterOption}
							/>
						</div>
						<div style={{ flexShrink: 0 }}>
							<div
								style={{
									padding: 24,
									display: 'flex',
									justifyContent: 'center',
									position: 'sticky',
									bottom: 0,
									background: '#fff',
								}}
							>
								<button
									type='button'
									onClick={props.onDeleteAllFilter}
									style={{
										background: '#5357DC',
										color: '#fff',
										border: 'none',
										borderRadius: 8,
										padding: '10px 32px',
										fontWeight: 600,
										fontSize: 16,
										cursor: 'pointer',
										boxShadow: '0 2px 8px rgba(58,134,255,0.08)',
										display: 'flex',
										alignItems: 'center',
										gap: 8,
									}}
								>
									<DeleteSweepIcon style={{ color: '#fff', marginRight: 8 }} />
									Clear Filters
								</button>
							</div>
						</div>
					</form>
				</LateralPanel>
			</div>
		</Slide>
	)
}

SalesFilterPanel.propTypes = {
	open: propTypes.bool.isRequired,
	onClose: propTypes.func,
	onDeleteAllFilter: propTypes.func,
	salesModels: propTypes.array,
	skus: propTypes.array,
	selectedSalesModels: propTypes.array,
	selectedSkus: propTypes.array,
	onFilterOptionClick: propTypes.func,
	onRemoveFilterOption: propTypes.func,
}

SalesFilterPanel.defaultProps = {
	open: false,
}

export default SalesFilterPanel

const FilterBlock = ({ title, options, field, onFilterOptionClick, selectedValues = [], onRemoveFilterOption }) => (
	<div style={{ marginTop: 25 }}>
		<Typography variant='subtitle2' style={{ fontWeight: 600 }}>
			{title}
		</Typography>

		<Select
			placeholder='Select an option'
			options={options}
			isSearchable
			value={null}
			onChange={(option) => {
				if (option && !selectedValues.includes(option.value)) {
					onFilterOptionClick && onFilterOptionClick(field, option.value)
				}
			}}
			styles={{ container: (b) => ({ ...b, marginTop: 8 }) }}
		/>

		<div
			style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: 8,
				marginTop: 12,
			}}
		>
			{selectedValues.map((val, i) => {
				const opt = options.find((o) => o.value === val)
				if (!opt) return null
				return (
					<button
						key={i}
						type='button'
						onClick={() => onRemoveFilterOption && onRemoveFilterOption(field, val)}
						style={{
							border: '1px solid #3A86FF',
							borderRadius: 12,
							padding: '6px 14px',
							background: '#E3F0FF',
							color: '#3A86FF',
							fontWeight: 600,
							fontSize: 14,
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							gap: 6,
						}}
						title={`Remove ${opt.label}`}
					>
						{opt.label}
						<DeleteIcon fontSize='small' style={{ marginLeft: 4 }} />
					</button>
				)
			})}
		</div>
	</div>
)

const PanelHeader = (props) => {
	const { title, onClose } = props
	const classes = panelLateralServicesStyles()

	return (
		<div className={classes.panelHeader}>
			<div className={classes.containerHeader}>
				<div className={classes.containerIcon}>
					<Fab size='medium' className={classes.faultWarrantyIconSelected} disabled={true}>
						<BarChartIcon className={classes.faultWarrantyIcon} style={{ color: '#fff' }} />
					</Fab>
				</div>
				<div className={classes.containerText}>
					<Typography gutterBottom variant='subtitle1' className={classes.title}>
						{title}
					</Typography>
				</div>
			</div>
			<div className={classes.grow} />
			<Fab className={classes.buttonClose} onClick={onClose}>
				<DeleteIcon />
			</Fab>
		</div>
	)
}
